import { LifebuoyIcon } from "@phosphor-icons/react/dist/csr/Lifebuoy";
import { CommandGroup, CommandItem } from "@volca/ui/components/ui/command";
import { openSupportChat, useHasPylonAccess } from "@/core/pylon";

export const SupportGroup = ({ onClose }: { onClose: () => void }) => {
  const hasAccess = useHasPylonAccess();
  if (!hasAccess) return null;

  return (
    <CommandGroup heading="Support">
      <CommandItem
        value="contact support chat"
        onSelect={() => {
          onClose();
          openSupportChat();
        }}
      >
        <LifebuoyIcon />
        <span>Contact support</span>
      </CommandItem>
    </CommandGroup>
  );
};
